/**
 * Service: ticketsApi
 */
angular.module('acme.common.service.ticketsApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('TicketsApiService', ['$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/administration/tickets/config';
        this.printers.service = endpoint + '/printers/config';
        return true;
      },

      list: function(props) {
        var q = '',
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'GET',
          url: av.init({ url: this.service + q, version: 'v2' })
        });
      },

      detail: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'GET',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'POST',
          url: av.init({ url: this.service, version: 'v2' }),
          data: props
        });
      },

      update: function(props, publish) {
        var av = new ApiVersionFactory(),
            q = publish ? '?publish=true' : '';

        return $http({
          method: 'PUT',
          url: av.init({ url: this.service + q, version: 'v2' }),
          data: props
        });
      },

      remove: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'DELETE',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },

      printers: {
        service: '',

        list: function(props) {
          var q = '',
            av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'GET',
            url: av.init({ url: this.service + q, version: 'v2' })
          });
        }
      }

    };

}]);